module.exports = __webpack_public_path__ + "static/media/sc8r_13.5c51ae07.png";